import React, { useEffect, useState } from "react";
import MenuCard from "./MenuCard";
import {
  Typography,
  Container,
  Box,
  CircularProgress,
  Paper,
  useTheme,
} from "@mui/material";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu"; // Importing an icon for aesthetic

const MenuList = ({ filter = "all" }) => {
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();

  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/menu`
        );
        const data = await response.json();
        console.log(data);
        const filteredData =
          filter === "all"
            ? data
            : data.filter((item) => item.category === filter);

        setMenuItems(filteredData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching menu details", error);
      }
    };
    fetchMenuItems();
  }, [filter]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ marginTop: 4, marginBottom: 4 }}>
      {menuItems.length > 0 ? (
        <MenuCard menuItems={menuItems} />
      ) : (
        <Paper
          elevation={3}
          sx={{
            p: 5,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: theme.palette.grey[200],
            borderRadius: 2,
          }}
        >
          <RestaurantMenuIcon sx={{ fontSize: 60, mb: 2 }} color="action" />
          <Typography
            variant="h4"
            component="h2"
            textAlign="center"
            color="textSecondary"
          >
            Our menu is being updated!
          </Typography>
          <Typography variant="subtitle1" component="p" mt={2}>
            Check back soon for exciting new dishes.
          </Typography>
        </Paper>
      )}
    </Container>
  );
};

export default MenuList;
